import React, { useEffect, useRef, useState } from 'react';
import PropTypes from 'prop-types';
import cn from 'classnames';
import isEmpty from 'lodash.isempty';
import isNumber from 'lodash.isnumber';

const AttributeGroupForm = ({ attributeGroup, onReset, onSave }) => {
	const programNameRef = useRef();
	const [programName, setProgramName] = useState('');
	const [programType, setProgramType] = useState('');
	const [patientVisitCost, setPatientVisitCost] = useState('');
	const [programNameHasError, setProgramNameHasError] = useState(false);
	const [patientVisitCostHasError, setPatientVisitCostHasError] = useState(false);

	useEffect(() => {
		// console.log(attributeGroup)
		setProgramName(attributeGroup.program_name || '');
		setProgramType(attributeGroup.program_type || '');
		setPatientVisitCost(attributeGroup.patient_evisit_cost || '');
		setProgramNameHasError(false);
		setPatientVisitCostHasError(false);
	}, [attributeGroup]);

	const handleSave = () => {
		let formHasError = false;
		setProgramNameHasError(false);
		setPatientVisitCostHasError(false);

		if (isEmpty(programName)) {
			formHasError = true;
			setProgramNameHasError(true);
		}
		if (isEmpty(patientVisitCost) || !isNumber(parseInt(patientVisitCost, 10))) {
			formHasError = true;
			setPatientVisitCostHasError(true);
		}

		if (!formHasError) {
			const newAttGroup = {
				...attributeGroup,
				program_name: programName,
				program_type: programType,
				patient_evisit_cost: patientVisitCost
			};
			onSave(newAttGroup);
		}
	};

	return (
		<form>
			<div className="row">
				<div className="col-md-3 col-md-offset-1">
					<div className={cn('form-group mb0', { 'has-error': programNameHasError })}>
						<label htmlFor="program-name" className="sr-only">Name</label>
						<input type="text" className="form-control" id="program-name"
							ref={programNameRef}
							value={programName} placeholder="Program Name"
							onChange={({ target }) => setProgramName(target.value)} />
					</div>
				</div>
				<div className="col-md-3">
					<div className="form-group mb0">
						<label htmlFor="program-type" className="sr-only">Type</label>
						<input type="text" className="form-control" id="program-type"
							value={programType} placeholder="Program Type"
							onChange={({ target }) => setProgramType(target.value)} />
					</div>
				</div>
				<div className="col-md-3">
					<div className={cn('form-group mb0', { 'has-error': patientVisitCostHasError })}>
						<label htmlFor="patient-evisit-cost" className="sr-only">Visit Fee</label>
						<div className="input-group">
							<span className="input-group-addon">$</span>
							<input type="number" className="form-control" id="patient-evisit-cost"
								value={patientVisitCost} placeholder="Visit Fee" step="0.01"
								onChange={({ target }) => setPatientVisitCost(target.value)} />
						</div>
					</div>
				</div>
				<div className="col-md-2">
					<button className="btn btn-primary mr-sm" onClick={handleSave}>Save</button>
					<button className="btn btn-default" type="reset" onClick={onReset}>Reset</button>
				</div>
			</div>
		</form>
	);
};

AttributeGroupForm.propTypes = {
	attributeGroup: PropTypes.object.isRequired,
	onReset: PropTypes.func.isRequired,
	onSave: PropTypes.func.isRequired
};

export default AttributeGroupForm;
